import { round } from "lodash";

export default function roundFreq(freq) {
	if (!freq) return "0.0";
	else if (freq.toString() === "1.0") return freq;
	else return round(freq, 2);
}
